import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Turntable, BarChart3 } from 'lucide-react'
// import { Hammer, Sliders } from 'lucide-react'
import { clsx } from 'clsx'
import { ThemeToggle } from './ThemeToggle'
// import { useAuthStore } from '@/store/authStore'

interface LayoutProps {
  children: React.ReactNode
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation()
  // const navigate = useNavigate()
  // const { user, isAuthenticated, clearAuth } = useAuthStore()
  
  const navigation = [
    { name: 'Visualizer', href: '/visualizer', icon: BarChart3 },
    // 暂时屏蔽
    // { name: 'Playground', href: '/playground', icon: Hammer },
    // { name: 'MIDI Controller', href: '/midi-controller', icon: Sliders },
    // { name: 'RealMix', href: '/realmix', icon: Video },
  ]

  const isActive = (href: string) => location.pathname === href
  
  // const handleLogout = () => {
  //   clearAuth()
  //   navigate('/auth')
  // }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-gray-900 dark:to-gray-800">
      {/* Header */}
      <header className="bg-white dark:bg-gray-900 shadow-sm border-b border-gray-200 dark:border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center space-x-3">
              <div className="bg-primary-500 p-2 rounded-lg">
                <Turntable className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900 dark:text-white">KGAutomix</h1>
                <p className="text-sm text-gray-500 dark:text-gray-400">Minisite</p>
              </div>
            </div>

            {/* Navigation */}
            <nav className="hidden md:flex space-x-8">
              {navigation.map((item) => {
                const Icon = item.icon
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={clsx(
                      'flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
                      isActive(item.href)
                        ? 'bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300'
                        : 'text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-gray-100 dark:hover:bg-gray-800'
                    )}
                  >
                    <Icon className="h-4 w-4" />
                    <span>{item.name}</span>
                  </Link>
                )
              })}
            </nav>

            {/* Actions */}
            <div className="flex items-center space-x-4">
              {/* 暂时隐藏登录入口
              {isAuthenticated() && user ? (
                <div className="flex items-center space-x-3">
                  <div className="flex items-center space-x-2 px-3 py-1 bg-sky-50 dark:bg-sky-900 rounded-lg">
                    <User className="h-4 w-4 text-sky-600 dark:text-sky-400" />
                    <span className="text-sm font-medium text-sky-700 dark:text-sky-300">
                      {user.username}
                    </span>
                  </div>
                  <button
                    onClick={handleLogout}
                    className="p-2 text-gray-400 hover:text-gray-500 transition-colors"
                    title="退出登录"
                  >
                    <LogOut className="h-5 w-5" />
                  </button>
                </div>
              ) : (
                <Link
                  to="/auth"
                  className="px-4 py-2 text-sm font-medium text-white bg-sky-500 hover:bg-sky-600 rounded-lg transition-colors"
                >
                  登录
                </Link>
              )}
              */}
              <ThemeToggle />
              {/* <button className="p-2 text-gray-400 hover:text-gray-500 transition-colors">
                <Settings className="h-5 w-5" />
              </button>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 text-gray-400 hover:text-gray-500 transition-colors"
              >
                <Github className="h-5 w-5" />
              </a> */}
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="md:hidden bg-gray-50 dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
          <div className="px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex space-x-4">
                {navigation.map((item) => {
                  const Icon = item.icon
                  return (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={clsx(
                        'flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200',
                        isActive(item.href)
                          ? 'bg-primary-100 dark:bg-primary-900 text-primary-700 dark:text-primary-300'
                          : 'text-gray-700 dark:text-gray-300 hover:text-primary-600 dark:hover:text-primary-400 hover:bg-white dark:hover:bg-gray-700'
                      )}
                    >
                      <Icon className="h-4 w-4" />
                      <span>{item.name}</span>
                    </Link>
                  )
                })}
              </div>
              {/* Mobile Theme Toggle */}
              <ThemeToggle />
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <div className="bg-primary-500 p-1.5 rounded">
                <Turntable className="h-4 w-4 text-white" />
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Built with WaveSurfer.js, React, and TypeScript
              </p>
            </div>
            
            <div className="flex items-center space-x-6 text-sm text-gray-500 dark:text-gray-400">
              <span>© 2025 KGAutomix Minisite</span>
              <span>•</span>
              <span>Versatile & Extensible</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
